const configuredHosts = String(process.env.REACT_APP_APP_HOSTS || "")
  .split(",")
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

export function isApplicationHost(value) {
  const host = String(value || "").trim().toLowerCase();
  return host === "app.logboek24.nl" || host.startsWith("app.") || configuredHosts.includes(host);
}
